// extracted by mini-css-extract-plugin
export default {"container":"asq82oBIv4L3jRyUyBwpPg==","two-fa-logo":"DgCp2oi5tbAgwwZj59zmLg==","two-fa-icon":"_7qlIsgBxGWQ43LwPwTrohg==","two-fa-back-button":"_0W3Z6zzlOxw1oivU-Fqm+A=="};